import {IPolicy} from "../PA.Core.IF.Policy";
import {BehaviorSubject} from "rxjs";
import {IUsrContext} from "../PA.Core.IF.User";
import {PAEnvironment} from "../PAEnvironment";
import * as _ from 'lodash'
import {PAdbContext} from "../PAdbContext";
import {esWB_Domain, esWB_Domain_Item} from "../PAdbSchema";
import {WB_DomainItemRow, WB_DomainRow} from "../PAdbSchemaRows";

export class PolicyHasRole
  implements
    IPolicy
{
  private static  dbContext: PAdbContext = undefined
  private _PolicyChanged: BehaviorSubject<IPolicy>
  private _UserContext: IUsrContext
  private _Wb_Cust_Id: number
  private _loadPromise: Promise<void>

  constructor(aWbCustomerId?: number ){

    this._PolicyChanged = new BehaviorSubject<IPolicy>(this)
    this._UserContext = PAEnvironment.getValue(PAEnvironment.UserContext)
    this._Wb_Cust_Id = aWbCustomerId || 0
    this._loadPromise = undefined

    if (!this._UserContext) {
      return
    }

  }

  get OnLoadComplete(): Promise<void> {

    if(this._loadPromise)
      return this._loadPromise

    this._loadPromise = new Promise<void>((resolve, error) => {
      let dbContext = PolicyHasRole.getDbContext()
      dbContext.findAll(esWB_Domain, {where: {DOMAIN_ID: 'User_Roles', DELETED_IND: {neq: '1'}}})
        .then((results: WB_DomainRow[]) => {
          if(_.isEmpty(results)){
            resolve()
            return
          }

          let domIds = _.map(results, (aRow) => aRow.cif.WB_DOM_ID)
          return dbContext.findAll(esWB_Domain_Item, {where: {WB_DOM_ID: {inq: domIds}, DELETED_IND: {neq: '1'}}})
        })
        .then((results: WB_DomainItemRow[]) => {
          let uc = this._UserContext
          let dctHasRoleById: {[id:string] : boolean } = <any> this

          _.forEach(results, (aRole) => {
            let aRoleId = aRole.cif.DOMAIN_ITEM_ID
            let bHasRole = false
            if(uc)
              bHasRole = uc.hasRoleId(aRoleId, this._Wb_Cust_Id)
            dctHasRoleById[aRoleId] = bHasRole
          })

          resolve()
        })
        .catch((err) => {
          error(err)
        })

    })

    return this._loadPromise

  }


  get PolicyChanged(): BehaviorSubject<IPolicy> {
    return this._PolicyChanged
  }


  static getDbContext(): PAdbContext {
    if(!PolicyHasRole.dbContext){
      PolicyHasRole.dbContext = new PAdbContext()
    }

    return PolicyHasRole.dbContext

  }


}
